import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Switch,
    FormControlLabel,
    CircularProgress,
    Alert,
    Stack,
    Button
} from "@mui/material";
import Layout from "../../layout/layout";
import api from "../../api/axios";

const CONFIG_KEY = "ramadan_coming_soon";

const toBool = (val) => {
    if (typeof val === "boolean") return val;
    if (typeof val === "string") return val.toLowerCase() === "true";
    if (typeof val === "number") return val === 1;
    return false;
};

const PackageManagement = () => {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState("");

    const fetchConfig = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.get("config/get/", { params: { key: CONFIG_KEY } });
            setEnabled(toBool(response.data));
        } catch (err) {
            setError("Failed to load current value");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    const handleToggle = async (event) => {
        const nextValue = event.target.checked;
        const prevValue = enabled;
        setEnabled(nextValue);
        setSaving(true);
        setError(null);
        setSuccess("");
        try {
            await api.put("config/update/key/", { key: CONFIG_KEY, value: nextValue });
            setSuccess("Updated successfully");
        } catch (err) {
            setEnabled(prevValue);
            setError("Failed to update value");
        } finally {
            setSaving(false);
        }
    };

    const body = (
        <Box>
            <Typography variant="h5" gutterBottom>
                Package Management
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Toggle the Ramadan coming soon flag.
            </Typography>

            <Stack spacing={2} sx={{ maxWidth: 420 }}>
                {error && <Alert severity="error">{error}</Alert>}
                {success && <Alert severity="success">{success}</Alert>}

                <FormControlLabel
                    control={
                        <Switch
                            checked={enabled}
                            onChange={handleToggle}
                            disabled={loading || saving}
                            color="primary"
                        />
                    }
                    label="ramadan_coming_soon"
                />

                {(loading || saving) && (
                    <Stack direction="row" spacing={1} alignItems="center">
                        <CircularProgress size={20} />
                        <Typography variant="body2" color="text.secondary">
                            {loading ? "Loading current value..." : "Saving..."}
                        </Typography>
                    </Stack>
                )}

                <Button variant="outlined" onClick={fetchConfig} disabled={loading}>
                    Refresh value
                </Button>
            </Stack>
        </Box>
    );

    return <Layout title="Package Management" body={body} />;
};

export default PackageManagement;
